import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 25 25'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M9.103 20.638q-2.1 0-3.558-1.457-1.458-1.456-1.457-3.559 0-.882.3-1.715.303-.832.863-1.51l3.531-4.246L6.53 3.638h12.116L16.394 8.15l3.53 4.247q.562.675.863 1.51.3.831.3 1.714 0 2.102-1.464 3.56-1.465 1.455-3.55 1.456zm3.485-4.76q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.277q0-.75.53-1.278.53-.53 1.278-.53.749 0 1.278.53.53.53.53 1.278 0 .747-.53 1.277-.531.53-1.278.53m-2.433-8.365h4.875l1.183-2.375h-7.25zM9.103 19.138h6.97q1.473 0 2.494-1.026 1.02-1.026 1.02-2.49 0-.619-.212-1.2a3.5 3.5 0 0 0-.606-1.051l-3.627-4.358h-5.083l-3.642 4.342a3.5 3.5 0 0 0-.612 1.059 3.5 3.5 0 0 0-.217 1.208q0 1.464 1.026 2.49t2.49 1.026'
    />
  </svg>
)
export default SvgComponent
